import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';

export class SnapchatActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.SNAPCHATACTION, apiHelper);
  }

  public loadCampaigns(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/campaigns?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public loadAdSquads(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/adsquads?integrationId=' + integrationId;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  loadReportHistory(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName('data') + 'snapchat/report-history/' + integrationId;
    let method = 'GET';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, method, null, null, headers);
  }

  loadSavedReports(integrationId: string): Observable<any> {
    let url = this.apiHelper.getServiceName('data') + 'snapchat/report-history/saved/' + integrationId;
    let method = 'GET';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, method, null, null, headers);
  }

  saveReportHistory(rhId: string, name: string): Observable<any> {
    let url = this.apiHelper.getServiceName('data') + 'snapchat/report-history/save/' + rhId;
    let method = 'PUT';
    let headers = this.apiHelper.getDefaultHeader();
    url += '?name=' + name;
    return this.apiHelper.apiCall(url, method, null, null, headers);
  }
}
